<template>
  <a-table
    :columns="columns"
    :data-source="list"
    bordered
    rowKey="id"
    :pagination="false"
    :loading="loading"
  >
    <!-- 类型 -->
    <template slot="loginStatus" slot-scope="text">
      <span v-if="$t('logs_login_type')[text]">
        {{ $t('logs_login_type')[text] }}
      </span>
      <span v-else>--</span>
    </template>

    <!-- 成功与否 -->
    <template slot="success" slot-scope="text">
      <span v-if="text">{{ $t('com_msg_success') }}</span>
      <span v-else>{{ $t('com_msg_fail') }}</span>
    </template>

    <!-- 登录时间 -->
    <template slot="timeLogin" slot-scope="text">
      <span v-if="text">{{ text | formatDate }}</span>
      <span v-else>--</span>
    </template>

    <!-- 登出时间 -->
    <template slot="timeLogout" slot-scope="text">
      <span v-if="text">{{ text | formatDate }}</span>
      <span v-else>--</span>
    </template>

    <!-- 登出原因  -->
    <template slot="logoutReason" slot-scope="text">
      <!-- 登出原因，0-认证失败拒绝，1-用户主动logout，2-用户断网超时退出，3-用户信息更新系统强制重新登录 -->
      <span v-if="$t('logs_logout_reason')[text]">
        {{ $t('logs_logout_reason')[text] }}
      </span>
      <span v-else>--</span>
    </template>

    <!-- 属地 -->
    <template slot="Location" slot-scope="text">
      {{ text | location }}
    </template>
  </a-table>
</template>
<script>
export default {
  props: {
    list: {
      type: [Array, Object],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: this.$t('logs_table_user'),
          dataIndex: 'executeUserName',
          align: 'center',
        },
        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
          width: 170,
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('com_table_type'),
          dataIndex: 'updateType',
          scopedSlots: { customRender: 'updateType' },
        },

        {
          title: this.$t('logs_table_data'),
          dataIndex: 'executeData',
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'executeTime',
          width: 170,
          scopedSlots: { customRender: 'executeTime' },
        },
      ],
    };
  },
};
</script>
